var _circle, _g, _tspan;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "462.16mm",
    height: "214.44mm",
    viewBox: "0 0 462.16 214.44",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-13.18,268.12)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 120.4,
    cy: -160.9,
    r: 107.22,
    fill: "#f2f2f2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3768,0,0,1.3768,313.09,61.592)",
    fill: "#1a1a1a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-192.54-119.92-0.25241-87.841 55.027 32.057 54.522-32.057 0.50483 88.598-19.941-0.25241-0.75725-52.25-34.329 18.679-34.834-18.931-0.25241 52.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-184.09-128.63v-63.988l45.561 26.378 46.192-25.873 0.25241 63.861h-2.398v-59.823l-43.542 25.115-43.92-24.863v59.318z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -160.02,
    cy: -156.06,
    r: 4.8191
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -113.08,
    cy: -156.06,
    r: 4.8191
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-157.59-137.15a21.657 18.562 0 0 0 21.48 16.242 21.657 18.562 0 0 0 21.481-16.242z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -158.51,
    cy: -153.48,
    r: 1.7849
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -114.51,
    cy: -153.48,
    r: 1.7849
  }))), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.97543 0 0 .97543 234.88 -110.65)",
    fill: "#1a1a1a",
    fontFamily: "'MS Gothic'",
    fontSize: "105.04px",
    letterSpacing: ".005425px",
    style: {
      lineHeight: 2.35,
      shapeInside: "url(#rect12690)",
      whiteSpace: "pre"
    },
    xmlSpace: "preserve"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "Calibri",
    fontWeight: "bold"
  }, "emify"))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b7230b9679a2fb1b04dddb670bb9aa36.svg";
export { ForwardRef as ReactComponent };